export default {
  hero_eyebrow: "CENTRUM ZASOBÓW USFANS SPREADSHEET",
  hero_h1: "USFans Spreadsheet — Poradniki, znaleziska, opinie i zasoby",
  hero_copy:
    "Poznaj najnowsze zasoby USFans Spreadsheet w jednym uporządkowanym centrum. Odkryj przydatne poradniki, informacje o produktach, wskazówki dotyczące wysyłki, opinie i zasoby bezpieczeństwa — stworzone, aby Twoje poszukiwania były szybsze i łatwiejsze.",
  hero_cta_primary: "Poznaj USFans Spreadsheet",
  hero_cta_secondary: "Przeglądaj najnowsze poradniki",
  hero_trust: "Niezależne źródło · Regularnie aktualizowane · Wielojęzyczne",
  main_btn_1: "usfans spreadsheet",
  main_btn_2: "kup teraz",
  dropdown_label: "Przeglądaj kategorie",
  dropdown_placeholder: "Wybierz kategorię…",
  categories_title: "Kupuj według kategorii",
  categories_subtitle: "Przejdź bezpośrednio do kategorii, której szukasz, na głównej stronie.",
  text_eyebrow: "O USFANS SPREADSHEET",
  text_title: "Czym jest USFans Spreadsheet?",
  text_p1:
    "USFans spreadsheet to uporządkowane, społecznościowe źródło, które gromadzi linki do produktów, znaleziska i odnośniki w jednym miejscu. Zamiast przeszukiwać rozproszone wpisy i wiadomości, ludzie używają go jako punktu startowego do przeglądania kategorii, porównywania opcji i podążania za wskazówkami w stronę interesujących ich produktów.",
  text_p2:
    "Dobre źródło w formie arkusza oszczędza czas, ponieważ grupuje produkty w czytelne kategorie — buty, bluzy, koszulki, kurtki i inne — i kieruje każdy wpis do jego źródła. Dzięki temu znacznie łatwiej przejść od poszukiwań do rzeczywistego przeglądania pełnej oferty na głównej stronie.",
  text_p3:
    "Ponieważ arkusz jest niezależnym źródłem, zawsze warto weryfikować linki, sprawdzać aktualne ceny i czytać szczegóły produktów bezpośrednio na stronie źródłowej przed podjęciem decyzji.",
  text_features_title: "Dlaczego arkusz pomaga",
  text_feature_1_title: "Uporządkowane odkrywanie",
  text_feature_1_desc: "Kategorie grupują produkty, dzięki czemu szybko znajdziesz to, czego potrzebujesz.",
  text_feature_2_title: "Szybsze poszukiwania",
  text_feature_2_desc: "Jedno centrum zastępuje godziny przewijania rozproszonych informacji.",
  text_feature_3_title: "Jasne kolejne kroki",
  text_feature_3_desc: "Każdy wpis kieruje Cię do strony źródłowej po pełne szczegóły.",
  article_entry_title: "Wyróżnione poradniki",
  article_entry_subtitle: "Oryginalne, szczegółowe artykuły pisane wokół tematu USFans spreadsheet.",
  article_1_tag: "Bezpieczeństwo",
  article_1_title: "Czy USFans jest legalne? Bezpieczeństwo, opinie i co warto wiedzieć",
  article_1_desc:
    "Uczciwe spojrzenie na to, jak zweryfikować USFans spreadsheet, rozpoznać sygnały ostrzegawcze i chronić się podczas poszukiwań online.",
  article_1_cta: "Czytaj poradnik",
  safety_title: "Bezpieczeństwo i ochrona USFans",
  safety_copy:
    "Przed skorzystaniem z jakiegokolwiek źródła online zweryfikuj adres strony, unikaj podejrzanych pobrań, chroń dane logowania i niezależnie weryfikuj ważne informacje. Ta strona jest niezależnym źródłem informacji i nie gwarantuje usług, produktów ani transakcji stron trzecich.",
  safety_cta: "Przeczytaj poradnik bezpieczeństwa USFans",
  cta_title: "Gotowy, by odkryć więcej?",
  cta_copy:
    "Skorzystaj z naszych poradników i zasobów arkusza, aby zbadać opcje, a następnie przejdź na główną stronę, gdy będziesz gotowy poznać pełne doświadczenie.",
  cta_primary: "Odwiedź główną stronę",
  cta_secondary: "Poznaj więcej poradników USFans",
  faq_title: "USFans Spreadsheet — FAQ",
  faq_q1: "Czym jest USFans spreadsheet?",
  faq_a1:
    "To uporządkowane źródło, które gromadzi linki do produktów, znaleziska i odnośniki w jednym, łatwym do przeglądania centrum, pogrupowane według kategorii.",
  faq_q2: "Jak działa USFans spreadsheet?",
  faq_a2:
    "Produkty są pogrupowane w kategorie, a każdy wpis kieruje do źródła na głównej stronie, dzięki czemu możesz przejść od poszukiwań do przeglądania jednym kliknięciem.",
  faq_q3: "Czy USFans jest legalne?",
  faq_a3:
    "USFansLink jest niezależnym źródłem. Zawsze weryfikuj linki, ceny i szczegóły produktów bezpośrednio na stronie źródłowej przed podjęciem decyzji.",
  faq_q4: "Co powinienem wiedzieć o kosztach wysyłki USFans?",
  faq_a4:
    "Koszt wysyłki zależy od strony źródłowej, Twojej lokalizacji i wybranej metody wysyłki. Sprawdź stronę zamówienia, aby uzyskać najdokładniejsze oszacowanie.",
  faq_q5: "Czy USFans oferuje kupony?",
  faq_a5:
    "Promocje i kody rabatowe, jeśli są dostępne, są zwykle pokazywane na stronie źródłowej. Zweryfikuj każdy kod przed użyciem.",
  faq_q6: "Gdzie mogę znaleźć kody rabatowe USFans?",
  faq_a6:
    "Kody rabatowe są zwykle wymieniane bezpośrednio na głównej stronie lub w jej sekcjach promocyjnych. Podchodź ostrożnie do nieoficjalnych kodów.",
  faq_q7: "Czym jest magazyn USFans?",
  faq_a7:
    "Magazyn odnosi się do strony przechowywania i realizacji zamówień na stronie źródłowej. Dokładne informacje znajdziesz w sekcji wysyłki i zamówień strony źródłowej.",
  faq_q8: "Jak powinienem sprawdzać informacje o USFans?",
  faq_a8:
    "Weryfikuj ważne szczegóły bezpośrednio na oficjalnej stronie źródłowej i bądź ostrożny wobec nieoficjalnych twierdzeń stron trzecich.",
};